import { createAction, createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

import { jobTitleApi } from './../lib/api';
import type { JobTitle } from '../lib/types/jobTitle';

export const FETCH_JOB_TITLE = 'vehicles/jobTitle/fetch';
export const ADD_JOB_TITLE = 'vehicles/jobTitle/add';
export const UPDATE_JOB_TITLE = 'vehicles/jobTitle/update';
export const CLEAN_JOB_TITLE = 'vehicles/jobTitle/clean';

export type JobTitleState = JobTitle | null;

const initialState: JobTitleState = null;

const fetchJobTitleAction = createAction<JobTitle>(FETCH_JOB_TITLE);
const addJobTitleAction = createAction<JobTitle>(ADD_JOB_TITLE);
const updateJobTitleAction = createAction<JobTitle>(UPDATE_JOB_TITLE);
const cleanJobTitleAction = createAction(CLEAN_JOB_TITLE);

const jobTitleSlice = createSlice({
  name: 'jobTitle',
  initialState: initialState as JobTitleState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchJobTitleAction, (_, { payload }) => ({ ...payload }))
      .addCase(addJobTitleAction, (_, { payload }) => ({ ...payload }))
      .addCase(updateJobTitleAction, (_, { payload }) => ({ ...payload }))
      .addCase(cleanJobTitleAction, () => initialState);
  }
});

export const jobTitleActions = {
  fetch: fetchJobTitleAction,
  add: addJobTitleAction,
  update: updateJobTitleAction,
  clean: cleanJobTitleAction
};

export const addJobTitle = (jobTitle: JobTitle) => async (
  dispatch: Dispatch
): Promise<void> => {
  const payload = await jobTitleApi.addJobTitle(jobTitle);
  dispatch(jobTitleActions.add(payload));
};

export const updateJobTitle = (jobTitle: JobTitle) => async (
  dispatch: Dispatch
): Promise<void> => {
  const payload = await jobTitleApi.updateJobTitle(jobTitle);
  dispatch(jobTitleActions.update(payload));
};

export const deleteJobTitle = (id: number) => async (
  dispatch: Dispatch
): Promise<void> => await jobTitleApi.deleteJobTitle(id);

export const fetchJobTitle = (id: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  const jobTitle = await jobTitleApi.fetchJobTitle(id);
  dispatch(jobTitleActions.fetch({ ...jobTitle }));
};

export const cleanJobTitle = () => (dispatch: Dispatch) =>
  dispatch(jobTitleActions.clean());

export default jobTitleSlice.reducer;
